import { render, staticRenderFns } from "./RefsEvent.vue?vue&type=template&id=bc97ac9a"
import script from "./RefsEvent.vue?vue&type=script&lang=ts"
export * from "./RefsEvent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports